import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import SimpleInput from 'components/SimpleInput';
import RadioButtons from 'components/RadioButtons';
import S from 'modal.scss';
import PhaseType from 'types/phase';
import { getPhaseErrors } from '../../../../../../../reducers';

class SurplusMaterial extends Resetter(Validator(React.Component)) {
  state = {
    surplusMaterials: this.props.surplusMaterials || '',
    customerInitials: this.props.customerInitials || '',
    errors: {},
  };

  static VALIDATIONS = {
    customerInitials: true,
  }
  surplusMaterialsRef = React.createRef();

  componentDidMount() {
    this.surplusMaterialsRef.current.scrollIntoView(false);
  }

  handleSubmit = () => {
    if (!this.validate()) { return; }
    this.props.updateFormData({
      surplusMaterials: this.state.surplusMaterials,
      customerInitials: this.state.customerInitials,
      tab: 4,
    });
  }

  handlePrevious = () => {
    this.props.updateFormData({
      surplusMaterials: this.state.surplusMaterials,
      customerInitials: this.state.customerInitials,
      tab: 2,
    });
  }

  handleSurplusMaterialChange = (value) => {
    this.setState({ surplusMaterials: value });
  }

  handleCustomerInitialsChange = (e) => {
    this.setState({ customerInitials: e.target.value });
  }

  render() {
    const { customerInitials, errors } = this.state;
    const radioButtons = [
      {
        label: 'There were no such surplus materials.',
        value: 'opt1',
      },
      {
        label: 'I accepted all surplus materials I wanted.',
        value: 'opt2',
      },
      {
        label: 'I declined to receive any surplus materials.',
        value: 'opt3',
      },
    ];

    return (
      <div ref={this.surplusMaterialsRef}>
        <h6 className={S.signatureTitle}>Part 3 - Surplus Materials</h6>
        <RadioButtons
          label="Customer Selects One*" required
          onChange={this.handleSurplusMaterialChange}
          selectedValue={this.state.surplusMaterials}
          radioButtons={radioButtons}
          text="Please select what should be done with remaining surplus materials:"
        />
        <SimpleInput label="Customer Initials*" required text={customerInitials} errors={errors.customerInitials} onChange={this.handleCustomerInitialsChange} />
        <Button label="Next" flat inverse ripple className={S.submit} onClick={this.handleSubmit} />
        <Button label="Previous" flat inverse ripple className={S.submit} onClick={this.handlePrevious} />
      </div>
    );
  }
}

SurplusMaterial.propTypes = {
  phase: PhaseType.isRequired,
  errors: PropTypes.shape({
    signature: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {})(SurplusMaterial);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/cocSignature/surplus_material.jsx